import React, { useEffect } from 'react';
//= Scripts
import scrollToTop from '../../Common/scrollToTop';

const ProgressScroll = () => {
  return null;
};

export default ProgressScroll;
